<template>
  <div class="settings-card generalConfig weflix-admin-general">
    <header class="settings-card__header">
      <span class="settings-card__icon" aria-hidden="true">
        <fa icon="fa-gear" />
      </span>
      <div>
        <h2 class="settings-card__title">Configurações Gerais</h2>
        <p class="settings-card__description">Personalize o sistema Weflix conforme suas necessidades.</p>
      </div>
    </header>

    <div v-if="hasReady">
      <div class="settings-option">
        <div class="settings-option__main">
          <span class="settings-option__icon" aria-hidden="true">
            <fa icon="fa-cart-shopping" />
          </span>
          <div>
            <label class="settings-option__title" for="setting-cart-closure">Fechamento de carrinho</label>
            <p class="settings-option__description">Quando ativado, impede a finalização de compras no checkout.</p>
          </div>
        </div>
        <div class="settings-option__controls">
          <span class="settings-badge" :class="cartClosure ? 'is-on' : 'is-off'">
            {{ cartClosure ? 'Ativado' : 'Inativo' }}
          </span>
          <div class="form-check form-switch">
            <input
              id="setting-cart-closure"
              class="form-check-input"
              type="checkbox"
              role="switch"
              v-model="cartClosure"
            />
          </div>
        </div>
      </div>

      <div class="settings-option">
        <div class="settings-option__main">
          <span class="settings-option__icon" aria-hidden="true">
            <fa icon="fa-credit-card" />
          </span>
          <div>
            <label class="settings-option__title" for="setting-installment-checkout">Exibir valor parcelado no checkout</label>
            <p class="settings-option__description">Mostra o valor das parcelas durante o processo de pagamento.</p>
          </div>
        </div>
        <div class="settings-option__controls">
          <span class="settings-badge" :class="showInstallmentValue ? 'is-on' : 'is-off'">
            {{ showInstallmentValue ? 'Ativado' : 'Inativo' }}
          </span>
          <div class="form-check form-switch">
            <input
              id="setting-installment-checkout"
              class="form-check-input"
              type="checkbox"
              role="switch"
              v-model="showInstallmentValue"
            />
          </div>
        </div>
      </div>

      <div class="settings-card__actions">
        <button type="button" class="settings-save" @click="updateCompany">Salvar alterações</button>
      </div>
    </div>
  </div>
  
  <div v-if="!hasReady" class="loader-overlay">
    <div class="loader-spinner"></div>
  </div>
</template>

<script>
import apiCompany from '@/utils/Weflix/company';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    data(){
        return{
            company: [],
            receivablesAdvance: false,
            mediaComments: false,
            cartClosure: false,
            googleSignIn: false,
            showInstallmentValue: false,
            id: '',
            hasReady: false,
        }
    },
    computed: {
        ...mapState(['token'])
    },
    methods: {
        ...mapActions(['storeCurrentCollections']),

        async getCompany(){
            try {
                const response = await apiCompany.getCompany(this.token);
                this.company = response;
                this.receivablesAdvance = response.anticipation === 1 ? true : false;
                this.mediaComments = response.videoComments === 1 ? true : false;
                this.cartClosure = response.cartStatus === 1 ? true : false;
                this.showInstallmentValue = response.intallmentCheckout === 1 ? true : false;
                this.id = response.id;
                this.hasReady = true;
            } catch (error) {
                console.error(error);
            }
        },
        async updateCompany(){
            this.hasReady = false;
            const payload = {
                "anticipation": this.receivablesAdvance ? 1 : 0,
                "videoComments": this.mediaComments ? 1 : 0,
                "cartStatus": this.cartClosure ? 1 : 0,
                "intallmentCheckout": this.showInstallmentValue ? 1 : 0,
                "name": this.company.name,
            }
            try {
                const response = await apiCompany.editCompany(this.token, payload);
                this.hasReady = true;
                this.notify('Configurações atualizadas com sucesso!', 'success');
            } catch (error) {
                this.notify('Erro ao atualizar configurações!', 'error');
                console.error(error);
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    }, 
    created(){
        this.getCompany();
    }
}
</script>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid #e7eaf2;
  border-radius: 12px;
  padding: 24px 24px 20px;
  box-shadow: 0 3px 14px rgba(20, 25, 60, 0.03);
  text-align: left;
}

.settings-card__header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 4px;
}

.settings-card__icon,
.settings-option__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1eeff;
  color: #4327c9;
}

.settings-card__icon :deep(svg.svg-inline--fa),
.settings-option__icon :deep(svg.svg-inline--fa) {
  color: #4327c9;
}

.settings-card__icon {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.settings-card__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #11143d;
  text-align: left;
}

.settings-card__description {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
  text-align: left;
}

.settings-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 84px;
  padding: 18px 0;
  border-top: 1px solid #e7eaf2;
}

.settings-option__main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.settings-option__main > div {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.settings-option__icon {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 10px;
}

.settings-option__title {
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #11143d;
  cursor: pointer;
  text-align: left;
}

.settings-option__description {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
  text-align: left;
}

.settings-option__controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.settings-badge {
  position: relative;
  z-index: 2;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 999px;
  white-space: nowrap;
  line-height: 1.2;
}

.settings-badge.is-on {
  background: #dcfce7;
  color: #166534;
}

.settings-badge.is-off {
  background: #fee2e2;
  color: #991b1b;
}

.settings-option__controls .form-check.form-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2.75rem;
  width: 2.75rem;
  min-height: 1.5rem;
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

.settings-option__controls .form-switch .form-check-input {
  float: none !important;
  width: 2.75rem !important;
  height: 1.5rem !important;
  margin: 0 !important;
  background-color: #e5e7eb;
  background-image: none !important;
  border: none;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  appearance: none;
  flex-shrink: 0;
}

.form-check-input:checked {
  background-color: #4327c9 !important;
}

.form-check-input::before {
  content: '';
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: #fff;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.form-check-input:checked::before {
  transform: translateX(1.25rem);
}

.settings-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 20px;
}

button.settings-save {
  height: 42px;
  padding: 0 20px;
  border: none;
  border-radius: 8px;
  background: #4327c9;
  color: #fff !important;
  -webkit-text-fill-color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.settings-save:hover {
  background: #341bae;
}

.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #4327c9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 640px) {
  .settings-card {
    padding: 16px;
  }

  .settings-option {
    align-items: flex-start;
    flex-direction: column;
  }

  .settings-option__controls {
    align-self: flex-end;
  }

  .settings-save {
    width: 100%;
  }
}
</style>
